import React, { useState } from "react";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { addInstitute } from "../../store/slices/institute";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { uploadsuperadminImage } from "../../utils/helpers/fileupload";

import {
  nameregex,
  emailregex,
  mobileregex,

} from "../../utils/Regex";


const requiredMessages = {
  username: "Please enter username",
  password: "Please enter password",
  instituteName: "Please enter institute name",
  instituteCode: "Please enter institute code",
  instituteMobileNo: "Please enter institute mobile number",
  instituteEmail: "Please enter institute email",
  instituteHeadName: "Please enter principal name",
  instituteHeadMobileNo: "Please enter principal mobile number",
  instituteHeadEmail: "Please enter principal email",
  instituteAddress: "Please enter institute address",
  institutePincode: "Please enter pincode",
  modules: "Please select at least one module",
};

export default function AddInstitution() {

  // access token
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user?.data?.accessToken;
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    instituteName: "",
    instituteCode: "",
    instituteLogo: "",
    instituteMobileNo: "",
    instituteEmail: "",
    instituteHeadName: "",
    instituteHeadEmail: "",
    instituteHeadMobileNo: "",
    instituteAddress: "",
    instituteCity: "",
    instituteState: "",
    institutePincode: "",
    modules: [],
  });

  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validateField = (name, value) => {
    let errorMessage = "";

    if (
      (!value || (Array.isArray(value) && value.length === 0)) &&
      requiredMessages[name]
    ) {
      errorMessage = requiredMessages[name];
    } else {
      if (
        ["instituteMobileNo", "instituteHeadMobileNo"].includes(name) &&
        value &&
        !mobileregex.test(value)
      ) {
        errorMessage = "Mobile number must be 10 digits";
      }

      if (
        ["instituteEmail", "instituteHeadEmail"].includes(name) &&
        value &&
        !emailregex.test(value)
      ) {
        errorMessage = "Please enter valid email";
      }

      if (
        ["instituteName", "instituteHeadName"].includes(name) &&
        value &&
        !nameregex.test(value)
      ) {
        errorMessage = "Only alphabets allowed";
      }
    }

    setErrors((prev) => ({
      ...prev,
      [name]: errorMessage,
    }));

    return !errorMessage;
  };

  /* ---------- Change ---------- */
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    validateField(name, value);
  };




  // filehandle 
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (!files[0]) return;

    setFormData((prev) => ({
      ...prev,
      [name]: files[0],
    }));
  };



  /* ---------- Submit ---------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    Object.keys(formData).forEach((key) => {
      const value = formData[key];

      let error = "";

      if (
        (!value || (Array.isArray(value) && value.length === 0)) &&
        requiredMessages[key]
      ) {
        error = requiredMessages[key];
      }

      if (
        ["instituteMobileNo", "instituteHeadMobileNo"].includes(key) &&
        value &&
        !mobileregex.test(value)
      ) {
        error = "Mobile number must be 10 digits";
      }

      if (
        ["instituteEmail", "instituteHeadEmail"].includes(key) &&
        value &&
        !emailregex.test(value)
      ) {
        error = "Please enter valid email";
      }

      if (error) {
        newErrors[key] = error;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fill all required fields correctly");
      return;
    }

    setErrors((prev) => ({ ...prev, ...newErrors }));


    try {

      let instituteLogoUrl = "";
      console.log(formData.instituteLogo);
      console.log(formData.instituteLogo instanceof File);
      if (formData.instituteLogo instanceof File) {
        instituteLogoUrl = await uploadsuperadminImage(
          formData.instituteLogo,
          token
        );
      }
      const payload = {
        ...formData,
        instituteLogo: instituteLogoUrl,
      };
      await dispatch(addInstitute(payload)).unwrap();

      toast.success("Institute added successfully");
      navigate("/sadmin/institute");


    } catch (err) {

      toast.error(err?.message || "Failed to add institute");
    }
  };
  const handleModuleChange = (module) => {
    setFormData((prev) => ({
      ...prev,
      modules: prev.modules.includes(module)
        ? prev.modules.filter((m) => m !== module)
        : [...prev.modules, module],
    }));
  };


  return (
    <Container fluid className="px-4">
      <Card className="addstudent-card">
        <Card.Header>
          <h5>Add Institute</h5>
        </Card.Header>

        <Card.Body>
          <Form onSubmit={handleSubmit}>

            {/* Institute Details */}
            <h6 className="mb-3 fw-bold">Institute Details</h6>

            <Row className="g-3 mb-4">
              <Col md={6}>
                <Form.Label>Institute Name</Form.Label>
                <Form.Control
                  name="instituteName"
                  value={formData.instituteName}
                  onChange={handleChange}
                  placeholder="Enter Institute Name"
                />
              </Col>

              <Col md={3}>
                <Form.Label>Institute Code</Form.Label>
                <Form.Control
                  name="instituteCode"
                  value={formData.instituteCode}
                  onChange={handleChange}
                  placeholder="OCT"
                />
              </Col>

              <Col md={3}>
                <Form.Label>Logo</Form.Label>
                <Form.Control
                  type="file"
                  name="instituteLogo"
                  onChange={handleFileChange}
                />
              </Col>

              <Col md={4}>
                <Form.Label>Institute Mobile</Form.Label>
                <Form.Control
                  name="instituteMobileNo"
                  value={formData.instituteMobileNo}
                  onChange={handleChange}
                  placeholder="Mobile Number"
                />
              </Col>

              <Col md={4}>
                <Form.Label>Institute Email</Form.Label>
                <Form.Control
                  name="instituteEmail"
                  value={formData.instituteEmail}
                  onChange={handleChange}
                  placeholder="info@example.com"
                />
              </Col>

              <Col md={4}>
                <Form.Label>Pincode</Form.Label>
                <Form.Control
                  name="institutePincode"
                  value={formData.institutePincode}
                  onChange={handleChange}
                  placeholder="560001"
                />
              </Col>

              <Col md={12}>
                <Form.Label>Address</Form.Label>
                <Form.Control
                  name="instituteAddress"
                  value={formData.instituteAddress}
                  onChange={handleChange}
                  placeholder="Enter Complete Address"
                />
              </Col>

              <Col md={6}>
                <Form.Label>City</Form.Label>
                <Form.Control
                  name="instituteCity"
                  value={formData.instituteCity}
                  onChange={handleChange}
                  placeholder="Bengaluru"
                />
              </Col>

              <Col md={6}>
                <Form.Label>State</Form.Label>
                <Form.Control
                  name="instituteState"
                  value={formData.instituteState}
                  onChange={handleChange}
                  placeholder="Karnataka"
                />
              </Col>
            </Row>

            {/* Principal Details */}
            <h6 className="mb-3 fw-bold">Principal Details</h6>

            <Row className="g-3 mb-4">
              <Col md={4}>
                <Form.Label>Principal Name</Form.Label>
                <Form.Control
                  name="instituteHeadName"
                  value={formData.instituteHeadName}
                  onChange={handleChange}
                  placeholder="Principal Name"
                />
              </Col>

              <Col md={4}>
                <Form.Label>Principal Mobile</Form.Label>
                <Form.Control
                  name="instituteHeadMobileNo"
                  value={formData.instituteHeadMobileNo}
                  onChange={handleChange}
                  placeholder="Mobile Number"
                />
              </Col>

              <Col md={4}>
                <Form.Label>Principal Email</Form.Label>
                <Form.Control
                  name="instituteHeadEmail"
                  value={formData.instituteHeadEmail}
                  onChange={handleChange}
                  placeholder="principal@example.com"
                />
              </Col>
            </Row>

            {/* Login Credentials */}
            <h6 className="mb-3 fw-bold">Login Credentials</h6>

            <Row className="g-3 mb-4">
              <Col md={6}>
                <Form.Label>Username</Form.Label>
                <Form.Control
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Username"
                />
              </Col>

              <Col md={6}>
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Password"
                />
              </Col>
            </Row>

            {/* Modules */}
            <h6 className="mb-3 fw-bold">Modules</h6>

            <Row className="mb-4">
              <Col md={12}>
                <Form.Label>Modules</Form.Label>

                <div className="d-flex flex-wrap gap-4 mt-2">
                  {["accounts", "fees", "admissions", "teacher"].map((module) => (
                    <Form.Check
                      key={module}
                      type="checkbox"
                      id={`module-${module}`}
                      label={module}
                      checked={formData.modules?.includes(module)}
                      onChange={() => {
                        setFormData((prev) => ({
                          ...prev,
                          modules: prev.modules.includes(module)
                            ? prev.modules.filter((m) => m !== module)
                            : [...prev.modules, module],
                        }));
                      }}
                    />
                  ))}
                </div>

                {errors.modules && (
                  <small className="text-danger">{errors.modules}</small>
                )}
              </Col>
            </Row>

            <div className="form-actions my-4">
              <button
                type="button"
                className="btn-cancel me-2"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>

              <button type="submit" className="btn-submit">
                Submit
              </button>
            </div>

          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}
